<template>
    <div class="collapsible-filter-panel">
        <div class="content-container">
            <div class="header-container">
                <b-button
                    variant="link"
                    class="toggle-button"
                    v-b-toggle="id"
                    v-test:toggleButton
                >
                    <span
                        class="title"
                        v-test:title
                    >
                        {{ title }}
                    </span>

                    <app-icon
                        name="chevron_up"
                        v-test:icon
                    />
                </b-button>
            </div>

            <b-collapse
                :id="id"
                class="filter-panel-collapse"
                v-model="visible"
                :accordion="accordion"
            >
                <div class="filter-panel-container">
                    <filter-panel
                        :filters="filters"
                        :type="type"
                        :selected-filters="selectedFiltersProxy"
                        @update:selectedFilters="updateSelectedFilters"
                        @close-panel="visible = false"
                    />
                </div>
            </b-collapse>
        </div>
    </div>
</template>

<script>
    import { BCollapse, VBToggle } from 'bootstrap-vue';
    import FilterPanel from '../FilterPanel/FilterPanel';
    import createPropProxy from '../../../lib/prop-proxies';

    export default {
        name: 'collapsible-filter-panel',

        components: { FilterPanel, BCollapse },

        directives: {
            'b-toggle': VBToggle,
        },

        props: {
            id: {
                type: String,
                required: true,
            },

            title: {
                type: String,
                required: true,
            },

            type: {
                type: String,
                default: 'multiple',
            },

            selectedFilters: {
                type: Array,
                default: () => ([]),
            },

            filters: {
                type: Array,
                default: () => ([]),
            },

            accordion: {
                type: String,
                default: '',
            },
        },

        data() {
            return {
                visible: false,
            };
        },

        computed: {
            /**
             * Create selectedFiltersProxy.
             *
             * @returns {object}
             */
            ...createPropProxy(['selectedFilters']),
        },

        methods: {
            /**
             * Update the selected filters.
             *
             * @param {object} val The new value.
             */
            updateSelectedFilters(val) {
                this.selectedFiltersProxy = val;
                this.$emit('update-selected-filters', val, this.id);
            },
        },
    };
</script>

<style lang="scss" scoped>
    .content-container {
        position: relative;
    }

    .header-container {
        display: flex;
        justify-content: flex-end;
    }

    .filter-panel-collapse {
        position: absolute;
        right: 0;
        top: 100%;
        z-index: 2;
        width: 640px;
        max-width: 100%;
    }

    .filter-panel-container {
        border: solid 2px primary-palette(1);
        border-bottom-left-radius: 50px;
        border-bottom-right-radius: 50px;
        padding: 15px 20px;
        background-color: #ffffff;

        @include media-breakpoint-up(md) {
            padding: 25px 45px;
        }
    }

    .toggle-button {
        border-radius: 0;
        white-space: nowrap;
        display: flex;
        align-items: center;

        &.collapsed {
            .app-icon {
                transform: rotate(180deg);
            }
        }
    }

    .title {
        margin-right: 5px;
    }
</style>
